import React from "react";
import { Row } from "react-bootstrap";
import { Routes, Route, useLocation } from "react-router-dom";
import debounce from "lodash.debounce";
import { MessagesPage } from "./MessagesPage";
import { MessagesSidebar } from "./components"
import { MessagePage } from "./MessagePage";
import { NavigationHelper } from "../helpers";
import { AccountWarnings } from "../components/AccountWarnings";

export const MessagesRouter: React.FC = () => {
  const location = useLocation();
  const [refreshKey, setRefreshKey] = React.useState("");

  React.useEffect(NavigationHelper.hideMobileSidebar, [location.pathname]) // eslint-disable-line

  const refreshSidebar = React.useMemo(() => debounce(() => {
      setRefreshKey(NavigationHelper.getRefreshKey());
    }, 300),[]);

  return (
    <>
      <a href="about:blank" onClick={e => { e.preventDefault(); NavigationHelper.toggleMobileSidebar() }} className="d-md-none" id="sidebarToggle"><i className="fas fa-bars"></i></a>
      <Row>
        <nav className="col-sm-3 col-md-2 d-none d-md-block bg-dark sidebar" id="sidebar">
          <MessagesSidebar refreshKey={refreshKey} />
        </nav>
        <main role="main" className="col-sm-12 ml-sm-auto col-md-10 pt-3">
          <AccountWarnings />
          <Routes>
            <Route path="/:id" element={<MessagePage refreshSidebar={refreshSidebar} />} />
            <Route path="/" element={<MessagesPage />} />
          </Routes>
        </main>
      </Row>
    </>
  );
};